import 'material-icons/iconfont/material-icons.css';
import '@rmwc/icon/icon.css';
import {createIcon, createOutlined, createRounded} from './Icon.utils';

export const AccountBalanceIcon = createIcon('account_balance');
export const AccountCircleOutlinedIcon = createOutlined('account_circle');
export const AddLocationIcon = createIcon('add_location');
export const AppsIcon = createIcon('apps');
export const ArrowBackIcon = createIcon('arrow_back');
export const ArrowDropDownIcon = createIcon('arrow_drop_down');
export const AttachFileIcon = createIcon('attach_file');
export const CallIcon = createIcon('call');
export const CancelOutlinedIcon = createOutlined('cancel');
export const CastOutlinedIcon = createOutlined('cast');
export const ChatIcon = createIcon('chat');
export const CheckCircleOutlinedIcon = createOutlined('check_circle');
export const CheckIcon = createIcon('check');
export const ChevronLeftIcon = createIcon('chevron_left');
export const ChevronRightIcon = createIcon('chevron_right');
export const ChevronRightOutlinedIcon = createOutlined('chevron_right');
export const CircleRoundedIcon = createRounded('circle');
export const CloseIcon = createIcon('close');
export const CreditCardOutlinedIcon = createOutlined('credit_card');
export const DeleteIcon = createIcon('delete');
export const DeviceHubIcon = createIcon('device_hub');
export const DevicesOtherOutlinedIcon = createOutlined('devices_other');
export const DnsOutlinedIcon = createRounded('dns');
export const DomainIcon = createIcon('domain');
export const Email = createIcon('email');
export const EmailRounded = createRounded('email');
export const ErrorIcon = createIcon('error');
export const ErrorOutlinedIcon = createOutlined('error_outlined');
export const ExpandLessIcon = createIcon('expand_less');
export const ExpandMoreIcon = createIcon('expand_more');
export const ExpandMoreOutlinedIcon = createOutlined('expand_more');
export const FacebookRounded = createRounded('facebook');
export const FiberPinIcon = createIcon('fiber_pin');
export const FirstPageIcon = createIcon('first_page');
export const GroupOutlinedIcon = createOutlined('group');
export const HelpIcon = createIcon('help');
export const HomeOutlinedIcon = createOutlined('home');
export const HubOutlinedIcon = createOutlined('hub');
export const InfoOutlinedIcon = createOutlined('info');
export const KeyboardArrowDownIcon = createIcon('keyboard_arrow_down');
export const LanguageOutlinedIcon = createOutlined('language');
export const LaunchIcon = createOutlined('launch');
export const LastPageIcon = createIcon('last_page');
export const LensIcon = createIcon('lens');
export const LensOutlinedIcon = createOutlined('lens');
export const LocalPhoneIcon = createIcon('local_phone');
export const LocationOnOutlinedIcon = createOutlined('location_on');
export const MailOutlinedIcon = createOutlined('mail');
export const MenuIcon = createIcon('menu');
export const MinimizeIcon = createIcon('minimize');
export const NavigateBeforeIcon = createIcon('navigate_before');
export const NavigateNextIcon = createIcon('navigate_next');
export const NetworkCheckOutlinedIcon = createOutlined('network_check');
export const OpenInNewIcon = createIcon('open_in_new');
export const OfflineBoltIcon = createIcon('offline_bolt');
export const PersonOutlinedIcon = createOutlined('person');
export const PhoneOutlinedIcon = createOutlined('phone');
export const PinIcon = createIcon('pin');
export const PlayCircleOutlineIcon = createOutlined('play_circle');
export const PublicOutlinedIcon = createOutlined('public');
export const RouterOutlinedIcon = createOutlined('router');
export const ScheduleOutlinedIcon = createOutlined('schedule');
export const SearchIcon = createOutlined('search');
export const SettingsInputHdmiOutlinedIcon = createOutlined(
  'settings_input_hdmi',
);
export const SettingsOutlinedIcon = createOutlined('settings');
export const SettingsRemoteOutlinedIcon = createOutlined('settings_remote');
export const SignalWifiOffOutlinedIcon = createOutlined('signal_wifi_off');
export const SmartphoneOutlinedIcon = createOutlined('smartphone');
export const SpeedOutlinedIcon = createOutlined('speed');
export const SupportOutlinedIcon = createOutlined('support');
export const TaskAltIcon = createIcon('task_alt');
export const TextSnippetOutlinedIcon = createOutlined('text_snippet');
export const TripOriginRoundedIcon = createRounded('trip_origin');
export const ViewCarouselOutlinedIcon = createOutlined('view_carousel');
export const VisibilityIcon = createIcon('visibility');
export const VisibilityOffIcon = createIcon('visibility_off');
export const VisibilityOutlinedIcon = createOutlined('visibility');
export const VisibilityOffOutlinedIcon = createOutlined('visibility_off');
export const WarningAmberIcon = createIcon('warning_amber');
export const WarningAmberOutlinedIcon = createOutlined('warning_amber');
export const WifiIcon = createIcon('wifi');
export const WifiOutlinedIcon = createOutlined('wifi');
export const WifiTetheringOutlinedIcon = createOutlined('wifi_tethering');
